import {djangoFetchJson} from 'common/report/queries/utils';

/**
 * Change the logged-in user's billing address.
 * @param {object} params - parameters for constructing API call
 * @param {string|number} params.bccEmail - new billing email address
 * @param {object} [options={}] - options for fetch call to API
 * @returns {object}
 * @returns {boolean} return.success - whether request succeeded
 */
export async function updateBillingEmail({bccEmail, accountId}, options = {}) {
  try {
    await djangoFetchJson(
      `/billing/bcc_email/`,
      {
        account_id: accountId,
        email: bccEmail,
      },
      options,
    );
  } catch (error) {
    error.userFriendly = true;
    throw error;
  }
  return {success: true};
}

/**
 * Change the logged-in user's receipt message.
 * @param {object} params - parameters for constructing API call
 * @param {string|number} params.receiptMessage - new receipt message
 * @param {object} [options={}] - options for fetch call to API
 * @returns {object}
 * @returns {boolean} return.success - whether request succeeded
 */
export async function updateReceiptMessage({receiptMessage, accountId}, options = {}) {
  try {
    await djangoFetchJson(
      `/billing/receipt_message/`,
      {
        account_id: accountId,
        receipt_message: receiptMessage,
      },
      options,
    );
  } catch (error) {
    error.userFriendly = true;
    throw error;
  }
  return {success: true};
}
